module.exports = __webpack_public_path__ + "static/img/lisboa.c27e2a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/lisboa.jpg
// module id = 3PLO
// module chunks = 1